import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Widget, { WidgetProps, ButtonPosition } from './components/Widget';
import retargetEvents from 'react-shadow-dom-retarget-events';

const blowup = (s: string): string => { throw new Error(s) };

const propsFromDataset = (dataset: DOMStringMap): WidgetProps => {
    const stylesheetPath = dataset.stylesheetPath || blowup(`data-stylesheet-path attribute must be supplied`);
    const activities = (dataset.activities || '').split(',');
    const maxGroupSize = parseInt(dataset.maxGroupSize || '9');
    const locationName = dataset.locationName || '';
    const schoolId = dataset.schoolId || blowup(`data-school-id attribute must be supplied`);
    const apiDomain = dataset.apiDomain || 'us-central1-outdr-prod.cloudfunctions.net';
    const fakeApi = dataset.fakeApi === 'true';
    const highlightColour = dataset.highlightColour || '#3E01F7';
    const customCss = decodeURIComponent(dataset.customCss || '');
    const buttonPosition = (dataset.buttonPosition || 'inline') as ButtonPosition;

    if (!schoolId) {
        throw new Error("schoolId must be provided to the widget, check settings/configuration")
    }

    return {
        stylesheetPath,
        activities,
        maxGroupSize,
        locationName,
        user: null,
        schoolId,
        apiDomain,
        fakeApi,
        highlightColour, 
        customCss,
        buttonPosition
    };
};

const widgets = Array.from(document.getElementsByClassName('outdr-widget'));

for (const widget of widgets) {
    const htmlElement = widget as HTMLDivElement;
    const props = propsFromDataset(htmlElement.dataset);

    const shadow = (htmlElement.attachShadow({ mode: 'closed' }) as unknown) as HTMLElement;

    const styleLink = document.createElement('link') as HTMLLinkElement;
    styleLink.href = props.stylesheetPath;
    styleLink.type = 'text/css';
    styleLink.rel = 'stylesheet';
    shadow.appendChild(styleLink);

    const styleElement = document.createElement('style') as HTMLStyleElement;
    styleElement.textContent = `
        :host {
            --brand-colour3: ${props.highlightColour};
        }
    `;
    shadow.appendChild(styleElement);

    if (props.customCss) {
        const customStyleElement = document.createElement('style') as HTMLStyleElement;
        customStyleElement.textContent = props.customCss;
        shadow.appendChild(customStyleElement);
    }

    const content = document.createElement('div');
    shadow.appendChild(content);

    ReactDOM.render(<Widget {...props} />, content);
    retargetEvents(shadow);
}

